module.exports = "./../fonts/roboto-condensed-v25-latin-regular.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-condensed-v25-latin-regular.ttf
// module id = 23
// module chunks = 0